<template>
  <div class="admin-page mx-2">
    <div class="finance-table my-2">
      <div class="my-table my-2">
        <div class="head">
          <div
            v-for="head_item in heads"
            :key="head_item"
            class="head_item title-blue d-inline-block"
          >
            <div class="inner-item">
              {{ head_item }}
            </div>
          </div>
        </div>
        <div class="body-table">
          <div
            v-for="(table_row, index) in financeElements"
            :key="table_row"
            class="body-row"
          >
            <div class="table_item d-inline-block">
              <div class="inner-item">
                {{ table_row.seller_name }}
              </div>
            </div>
            <div class="table_item d-inline-block">
              <div class="inner-item">
                {{ table_row.order_sum }}
              </div>
            </div>
            <div class="table_item d-inline-block">
              <div class="inner-item">
                {{ table_row.golpino_deposit_sum }}
              </div>
            </div>
            <div class="table_item d-inline-block">
              <div class="inner-item">
                {{ table_row.order_sum - table_row.golpino_deposit_sum }}
              </div>
            </div>
            <div class="table_item d-inline-block">
              <div class="inner-item w-100">
                <div class="w-100 mb-1">
                  <input
                    @click="as_deposite(index)"
                    v-model="table_row.my_amount"
                    class="w-100 py-2 px-2 out-none amount-input rounded"
                    placeholder="مبلغ"
                    type="number"
                  />
                </div>
                <div v-if="table_row.my_amount" class="w-100 clearfix mb-1">
                  <button
                    @click="as_deposite(index)"
                    :class="index + 1 == depositeActive ? 'active' : ''"
                    class="two-state-btn admin right w-50 rounded"
                  >
                    واریز
                  </button>
                  <button
                    @click="as_withdraw(index)"
                    :class="index + 1 == withdrawActive ? 'active' : ''"
                    class="two-state-btn seller left w-50 rounded" 
                  >
                    برداشت
                  </button>
                </div>
                <div class="mb-1">
                  <textarea
                    class="w-100 px-2 py-1 out-none description"
                    rows="3"
                    placeholder="توضیحات"
                    v-if="table_row.my_amount"
                    v-model="table_row.my_description"
                  ></textarea>
                </div>
                <button
                  v-if="table_row.my_amount"
                  @click="submit(table_row, index)"
                  class="w-100 submit rounded"
                >
                  ثبت
                </button>
              </div>
            </div>
            <div class="table_item d-inline-block">
              <div class="inner-item w-100">
                <router-link :to="'finances/' + table_row.seller_id">
                  <button type="button" class="btn">جزئیات</button>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Service from "../../../utils/admin-service";
import { computed, onMounted, ref, watch,inject } from "@vue/composition-api";

export default {
  setup() {
    // intro

    const heads = ref({
      seller_name: "نام",
      order_sum: "بستانکار",
      golpino_deposit_sum: "بدهکار",
      account_remain: "مانده",
      finance: "پرداخت",
      detailes: "جزئیات",
    });
    const financeElements = ref([]);
    const search_store = ref();
    const transactions = ref(null);

    const theService = computed(() => {
      return Service(false);
    });
    const global = inject("global");
    // functions
    const depositeActive = ref(true);
    const withdrawActive = ref(false);
    const as_deposite = function (index) {
      depositeActive.value = index + 1;
      withdrawActive.value = false;
    };
    const as_withdraw = function (index) {
      withdrawActive.value = index + 1;
      depositeActive.value = false;
    };
    //
    const submit = function (table_row, index) {
      var my_amount = table_row.my_amount;
      var my_description = table_row.my_description;
      if (depositeActive.value == index + 1) {
        var my_status = 0;
      }
      if (withdrawActive.value == index + 1) {
        var my_status = 1;
      }

      console.log(my_amount, my_description, my_status);

      let form_data = new FormData();
      form_data.append("value", my_amount);
      form_data.append("status", my_status);
      if (my_description !== "undefined") {
        form_data.append("desc", my_description);
      }

      theService.value.transmit(
        "admin/accounting/transaction/" + table_row.seller_id,
        form_data,
        (s, d) => {
          if (s == 200) {
            console.log("send data successfully");
            global.alertToggle("درخواست موفقیت آمیز بود!");
          }else{
            global.alertToggle("خطا در ارسال اطلاعات");
          }
          
        },
        (s, e) => {}
      );
    };
    //
    const isMobile = ref(null);
    const isDesktop = ref(null);
    const my_width = ref(null);
    const handleResize = () => {
      my_width.value = window.innerWidth;
      if (my_width.value > 700) {
        isMobile.value = false;
        isDesktop.value = true;
      } else {
        isMobile.value = true;
        isDesktop.value = false;
      }
    };
    //

    // mounte
    onMounted(() => {

      theService.value.receive(
        "admin/accounting",
        {},
        (s, d) => {
          if (s == 200) {
            financeElements.value = d.data;
          }
        },
        (s, e) => {}
      );
    });

    // returns
    return {
      heads,
      financeElements,
      transactions,
      search_store,
      isMobile,
      isDesktop,
      my_width,
      as_deposite,
      as_withdraw,
      depositeActive,
      withdrawActive,
      submit,
    };
  },
};
</script>

<style lang="scss" scoped>
.finance-table {
  border-radius: 10px;
  font-weight: lighter;
}
.my-table {
  background: #fff;
  border-radius: 10px;
  overflow: auto;
  // border: solid 1px #f7befd;
  box-shadow: 1px 1px 3px #ffc4fe8c;
  .head,
  .body-table {
    text-align: right;
  }
  background: #fff;
  .head {
    background: rgb(235, 235, 235);
  }
  .v-text-field > .v-input__control > .v-input__slot > .v-text-field__slot {
    background: rebeccapurple;
  }
}
.auto-table {
}
.search {
  background: #defffd;
}

.head_item {
  background: #f8fcff;
  text-align: center;
  width: calc(100% / 6);
  border: solid 1px #fff;
  line-height: 1.2;
  font-size: 12px;
  font-weight: bold;
  color: #0531b9;
  min-height: 59px;
  vertical-align: top;
  position: relative;

  &:last-child {
    border-left: solid 1px #fce3ff;
  }
  &.mini {
  }
}
.table_item {
  background: #f8fcff;
  text-align: center;
  width: calc(100% / 6);
  border: solid 1px #fff;
  line-height: 1.2;
  font-size: 11px;
  min-height: 150px;
  vertical-align: top;
  position: relative;
  color: #3f51b5;
  font-weight: 400;

}
.inner-item {
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  left: 50%;
}
.comment-reply {
  background-color: #ece8e8;
  border-radius: 4px;
}
.two-state-btn {
  padding: 10px;
  background: rgb(104, 104, 104);
  outline: none;
  &.admin {
    background: #ef85ba4d;
    &.active {
      font-weight: bold;
      background: #eb55a0;
      color: white;
      box-shadow: 1px 1px 5px #1b2d75;
    }
  }
  &.seller {
    background: #85cdef3a;
    &.active {
      font-weight: bold;
      background: #93dbfc;
      color: white;
      box-shadow: 1px 1px 5px #1b2d75;
    }
  }
}
.side {
  margin: 0 -3px;
}
.out-none {
  outline: none;
}
.submit {
  padding: 5px;
  color: white;
  outline: none;
  width: 100%;
  background: #0a77cd;
  &:hover {
    background: #2196f3;
  }
}
.amount-input {
  border: solid 1px rgb(231, 231, 231);
}
</style>